module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_sns_05-908795e293ceb555a40dfd4ea9d5ae5b.jpg";